<ag-grid-angular
  #recordingJobHistoryGrid
  class="ag-theme-balham recording-history-grid"
  [columnDefs]="columnDefs"
  (gridReady)="onGridReady($event)"
  [gridOptions]="gridOptions"
  [ngClass]="{ 'hide-pagination': hidePagination }"
></ag-grid-angular>
